import type {BdResource} from "@bindoc-projects/resource-domain-lib";
import { ShareableType} from "@bindoc-projects/resource-domain-lib";

export class AysVirtualClinicReferralImport implements BdResource {

    public static fromObj(obj: any): AysVirtualClinicReferralImport {
        return new AysVirtualClinicReferralImport(
            obj.id,
            obj.originalFileName,
            obj.importCaseCount,
            obj.relevantCaseCount,
            obj.recipientEmailAddress,
            obj.status,
            obj.virtualClinicId,
            obj.blobReference,
            obj.createdDate,
            obj.modifiedDate,
            obj.year
        )
    }

    resourceName = ShareableType.VIRTUAL_CLINIC_REFERRAL_IMPORT;

    constructor(
        public id: string,
        public name: string,
        public importCaseCount: number,
        public relevantCaseCount: number,
        public recipientEmailAddress: string,
        public status: 'ERROR' | 'SUCCESS' | 'WAITING' | 'IN_PROGRESS',
        public virtualClinicId: string,
        public blobReference: {containerName: string, fileName: string},
        public createdDate: Date,
        public modifiedDate: Date,
        public year: string
    ) {
    }

  clone(): AysVirtualClinicReferralImport {
    return new AysVirtualClinicReferralImport(
      this.id,
      this.name,
      this.importCaseCount,
      this.relevantCaseCount,
      this.recipientEmailAddress,
      this.status,this.virtualClinicId,
      {...this.blobReference},
      this.createdDate,
      this.modifiedDate,
      this.year
    );
  }
}
